export const LANGUAGE_OPTIONS = [
  { value: "en-AU", display_value: "English (AUS)" },
  { value: "en-CA", display_value: "English (CAN)" },
  { value: "en-GB", display_value: "English (UK)" },
  { value: "en-US", display_value: "English (US)" },
  { value: "fr-CA", display_value: "French (Canada)" },
];
